<div class="container p-5">
  <div class="row pt-5 pb-3">
    <div class="col-md-12">
      <h2 class="mat-heading-large" i18n=":@@events.title">Events</h2>
    </div>
  </div>
  <div class="row mb-5">
    <div class="col-md-12">
      <a
        routerLink="/events/swissjam25"
        class="text-decoration-none"
        style="color: inherit"
      >
        <mat-card class="overflow-hidden">
          <div mat-card-image style="position: relative; height: 200px">
            <img
              ngSrc="/assets/swissjam/swissjam0.jpg"
              fill
              class="object-fit-cover"
            />
          </div>
          <mat-card-header>
            <mat-card-title>Swiss Jam 25</mat-card-title>
            <mat-card-subtitle>{{
              readableStartDate !== readableEndDate
                ? readableStartDate + " - " + readableEndDate
                : readableStartDate
            }}</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content></mat-card-content>
        </mat-card>
      </a>
    </div>
  </div>
</div>
